import * as App from '../../app';
import { Canvas, CANVAS_SCALE, Metrika } from '../../lib/classes';
import { initData, getSlices } from '../../utils';
import { NextButton } from './NextButton/NextButton';
import { roundRect } from '../../lib/utils';
import { PHRASES, t } from '../../translate';
import { USE_ROTATE } from '../../app/const/features';
import { GRID_SIZE } from '../../app/const/game';
import { calcCellSize, calcGridPos } from '../../components/Game/src/geometry';
import './Instructor.less';
var root = null;
var canvas = null;
var btn = null;
var PAGES;
(function (PAGES) {
    PAGES[PAGES["HORIZONTAL"] = 0] = "HORIZONTAL";
    PAGES[PAGES["VERTICAL"] = 1] = "VERTICAL";
    PAGES[PAGES["CUBE"] = 2] = "CUBE";
    PAGES[PAGES["ROTATE"] = 3] = "ROTATE";
    PAGES[PAGES["DONE"] = 4] = "DONE";
})(PAGES || (PAGES = {}));
var page = PAGES.HORIZONTAL;
var Instructor = /** @class */ (function () {
    function Instructor(setData, getData, finish, rotate) {
        var _this = this;
        this.onResize = function () {
            canvas.resize(window.innerWidth, window.innerHeight);
            _this.draw();
        };
        this.setData = setData;
        this.getData = getData;
        this.finish = finish;
        this.rotate = rotate;
        if (!canvas) {
            root = document.createElement('DIV');
            document.body.appendChild(root);
            root.className = 'Instructor';
            canvas = new Canvas(window.innerWidth, window.innerHeight);
            window.addEventListener('resize', this.onResize);
            root.appendChild(canvas.canvas);
            canvas.canvas.style.position = 'absolute';
            canvas.canvas.style.left = '0';
            canvas.canvas.style.top = '0';
            canvas.canvas.style.zIndex = '100';
            this.hand = document.createElement('DIV');
            this.hand.className = 'Instructor-hand';
            root.appendChild(this.hand);
            // circle
            var circle = document.createElement('DIV');
            circle.className = 'Instructor-circle';
            this.hand.appendChild(circle);
            // pointer
            var pointer = document.createElement('DIV');
            pointer.className = 'Instructor-pointer';
            this.hand.appendChild(pointer);
            this.draw();
            App.emitter.on('lang', function () { return _this.draw(); });
        }
        Metrika.params({ learn: { start: 1 } });
    }
    Instructor.prototype.getCanvas = function () {
        return canvas.canvas;
    };
    Instructor.prototype.onDrop = function (countDeleted) {
        var _a;
        var _this = this;
        if (page < PAGES.ROTATE) {
            if (countDeleted === 9) {
                page += 1;
                if (!USE_ROTATE && page == PAGES.ROTATE) {
                    page += 1;
                }
                this.hand.style.display = 'none';
                setTimeout(function () { return _this.draw(); }, 800);
                Metrika.params({ learn: (_a = {}, _a["page-".concat(page)] = 1, _a) });
            }
            else {
                this.draw();
            }
        }
        else {
            this.draw();
        }
    };
    Instructor.prototype.onRotate = function () {
        var _this = this;
        if (page === PAGES.ROTATE) {
            this.rotate();
            this.hand.style.display = 'none';
            setTimeout(function () {
                page = PAGES.DONE;
                _this.draw();
            }, 1200);
        }
        else {
            this.draw();
        }
    };
    Instructor.prototype.draw = function () {
        var _this = this;
        if (!canvas) {
            return;
        }
        canvas.clear();
        var alpha = page === PAGES.DONE ? 0.85 : 0.75;
        canvas.fillRect(0, 0, window.innerWidth, window.innerHeight, "rgba(0,0,0,".concat(alpha, ")"));
        Instructor.drawHeader();
        var cellSize = calcCellSize();
        var gridPos = calcGridPos(cellSize);
        if (page === PAGES.HORIZONTAL) {
            var x = gridPos.x - 5;
            var y = gridPos.y + 3 * cellSize + 5;
            var w = cellSize * 9 + 10;
            var h = 3 * cellSize - 10;
            // путь у слайсику
            var x2 = gridPos.x + cellSize * 3;
            var y2 = gridPos.y + 6 * cellSize - 5;
            var w2 = cellSize * 3;
            var h2 = cellSize * 6;
            Instructor.clearRects([
                [x, y, w, h],
                [x2, y2, w2, h2],
            ]);
            var data = makeData([36, 37, 38, 39, 41, 42, 43, 44]);
            var slices = getSlices(10, 5, 3);
            this.setData(data, slices);
            this.drawHand(4.5, 4.5, 6);
        }
        else if (page === PAGES.VERTICAL) {
            var x = gridPos.x - 5;
            var y = gridPos.y + 2 * cellSize + 5;
            var w = cellSize * 3 + 10;
            var h = 10 * cellSize - 10;
            Instructor.clearRects([[x, y, w, h]]);
            var data = makeData([0, 9, 18, 54, 63, 72]);
            var slices = getSlices(15, 10, 5);
            this.setData(data, slices);
            this.drawHand(0.5, 4.5, 6);
        }
        else if (page === PAGES.CUBE) {
            var x = gridPos.x + 3 * cellSize - 5;
            var y = gridPos.y + 2 * cellSize + 5;
            var w = cellSize * 3 + 10;
            var h = 10 * cellSize - 10;
            Instructor.clearRects([[x, y, w, h]]);
            var data = makeData([30, 31, 32, 39, 41]);
            var slices = getSlices(1, 11, 1);
            this.setData(data, slices);
            this.drawHand(4.5, 5.5, 5.5);
        }
        else if (page === PAGES.ROTATE) {
            var x = gridPos.x - 5;
            var y = gridPos.y + 9 * cellSize + 5;
            var w = cellSize * 3 + 10;
            var h = 3 * cellSize - 10;
            Instructor.clearRects([[x, y, w, h]]);
            var data = makeData([]);
            var slices = getSlices(1, 11, 1);
            this.setData(data, slices);
            this.drawHand(1.2, 10.5, 1);
            this.hand.className = 'Instructor-hand Instructor-hand_rotate';
        }
        else if (page === PAGES.DONE) {
            if (!btn) {
                btn = new NextButton({
                    onClick: function () {
                        _this.remove();
                        Metrika.params({ learn: { done: 1 } });
                    },
                });
                root.appendChild(btn.render());
            }
            this.hand.style.display = 'none';
        }
    };
    Instructor.prototype.remove = function () {
        document.body.removeChild(root);
        root = null;
        this.finish();
        window.removeEventListener('resize', this.onResize);
    };
    Instructor.prototype.drawHand = function (left, top, height) {
        var cellSize = calcCellSize();
        var gridPos = calcGridPos(cellSize);
        this.hand.style.display = 'block';
        this.hand.className = 'Instructor-hand';
        this.hand.style.left = Math.floor(gridPos.x + left * cellSize) + 'px';
        this.hand.style.top = Math.floor(gridPos.y + top * cellSize) + 'px';
        this.hand.style.height = Math.floor(height * cellSize) + 'px';
    };
    Instructor.clearRects = function (rects) {
        for (var _i = 0, rects_1 = rects; _i < rects_1.length; _i++) {
            var rect = rects_1[_i];
            var x = rect[0], y = rect[1], w = rect[2], h = rect[3];
            var delta = 6;
            roundRect(canvas, x - delta, y - delta, w + 2 * delta, h + 2 * delta, 4, '#CCCC00');
        }
        for (var _a = 0, rects_2 = rects; _a < rects_2.length; _a++) {
            var rect = rects_2[_a];
            var x = rect[0], y = rect[1], w = rect[2], h = rect[3];
            canvas.clearRect(x, y, w, h);
        }
    };
    Instructor.drawHeader = function () {
        var y = calcGridPos(calcCellSize()).y;
        if (page >= PAGES.DONE) {
            return;
        }
        var fontSize = window.innerWidth > 700 ? 30 : 20;
        var n = USE_ROTATE ? 4 : 3;
        Instructor.fillText("".concat(t(PHRASES.Learning), " (").concat(t(PHRASES.step), " ").concat(page + 1, " ").concat(t(PHRASES.of), " ").concat(n, ")."), fontSize, y);
        Instructor.fillText(getSubHeader(page), fontSize - 6, y + fontSize + 15);
    };
    Instructor.fillText = function (text, fontSize, y) {
        canvas.ctx.fillStyle = '#fff';
        canvas.ctx.font = fontSize * CANVAS_SCALE + 'px Arial';
        canvas.fillCenterText(text, y);
    };
    return Instructor;
}());
export { Instructor };
function getSubHeader(page) {
    switch (page) {
        case PAGES.HORIZONTAL:
            return t(PHRASES.Line_up_the_puzzle_horizontally);
        case PAGES.VERTICAL:
            return t(PHRASES.Line_up_the_puzzle_vertically);
        case PAGES.CUBE:
            return t(PHRASES.Make_a_square);
        case PAGES.ROTATE:
            return t(PHRASES.CLICK_TO_SHAPE);
    }
}
function makeData(indexes) {
    var data = initData(GRID_SIZE * GRID_SIZE);
    for (var _i = 0, indexes_1 = indexes; _i < indexes_1.length; _i++) {
        var i = indexes_1[_i];
        data[i].value = 1;
    }
    return data;
}
